module.exports = __webpack_public_path__ + "why11.png?672a2e73405dbda29659b815bd055498";